module.exports = __webpack_public_path__ + "img/101011.fd957a48.png";